
<!-- 瀑布流组件 -->
<template>
  <div class="upgrade">
    <div class="list">
      <div class="img-list-wrap">
        <div
          @click="toDetail(item, 1)"
          class="img-wrap"
          v-for="(item, index) in this.dataArr"
          :key="index"
          :style="{ width: (item.width * 200) / item.height + 'px' }"
        >
          <div class="wrappertop" style="opacity: 0; bottom: -50px">
            <div class="topCom">{{ item.name }}</div>
          </div>
          <img class="img" :src="item.src" alt="精品图片" />
          <img
            src="../imgs/play.svg"
            v-show="msgFormSon == 3"
            class="play-btn"
            @click="checkVideo(item.id)"
          />

          <div class="wrapperbottom" style="opacity: 0; bottom: -50px">
            <span
              style="
                display: inline-block;
                padding: 12px 10px 0px 12px;
                float: left;
              "
            >
              <img
                :src="item.user.user_url"
                alt=""
                style="
                  width: 30px;
                  height: 30px;
                  border-radius: 50%;
                  float: left;
                "
              />
              <span
                style="
                  float: right;
                  line-height: 30px;
                  margin-left: 6px;
                  color: #fff;
                  font-size: 14px;
                  font-weight: 700;
                "
                >{{ item.user.user_name }}</span
              >
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script >
export default {
  name: "upgrade",
  props: ["dataArr", "msgFormSon"],
  data() {
    return {
      imgs: [],
      //   dataArr: [],
    };
  },
  created() {
    console.log(this.dataArr);
    console.log(this.msgFormSon);
  },
};
</script>
<style lang="scss" scoped>
.img-list-wrap {
  display: flex;
  flex-wrap: wrap;
  padding: 0 5px;
}

.img-list-wrap::after {
  content: "";
  /* flex-grow: 999999999; */
}

.img-wrap {
  display: block;
  margin: 5px;
  background-color: #ffffff;
  position: relative;
  flex-grow: 1;
  min-height: 200px;
  overflow: hidden;
  background: greenyellow;
  cursor: pointer;
  // display:table;
}

.img-wrap > .img {
  min-width: 100%;
  max-width: 100%;
  min-height: 200px;
  max-height: 300px;
  height: 100%;
  object-fit: cover;
  vertical-align: bottom;
  vertical-align: right;
}
.wrappertop {
  // width: 100%;
  height: 50px;
  line-height: 50px;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: -50px;
  background: -webkit-linear-gradient(
    bottom,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.3)
  );
  opacity: 0;
  color: #fff;
  .topCon {
    padding-right: 12px;
    display: inline-block;
    float: right;
    height: 50px;
    line-height: 38px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    max-width: 50%;
    text-align: right;
  }
}
.wrapperbottom {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  bottom: -50px;
  background: -webkit-linear-gradient(
    top,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.3)
  );
  opacity: 0;
  color: #fff;
}
.play-btn {
  position: absolute;
  width: 44px;
  height: 44px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/upgrade.vue